import Backbone from 'backbone';

class MobileMenu extends Backbone.View {
	get events() {
		return {
            'click .sma-mobile-menu-trigger': 'clickMenuTrigger',
            'click .sma-js-close-mobile-menu': 'clickMenuClose',
		};
	}

	initialize() {
        this.setElement('body');
    }

    clickMenuTrigger(el) {
        let target = $(el.currentTarget);
        let id = target.data('container-id');

        // Mobile menu container
        this.mobileMenu = $(`#${id}`);

        // Add shade to body
        this.menuShade = $('<div class="sma-menu-shade hidden-md-up"></div>');
        this.menuShade.appendTo('.sma-applicant-nav');

        this.menuShade.show();

        this.menuShade.animate({
			opacity: 1,
		}, 400);

        // Add Close button
        let ariaLabel = gettext('Close');
        this.mobileMenu.prepend('<a href="#" class="sma-js-close-mobile-menu sma-close-mobile-menu" aria-label="' + ariaLabel + '"><i class="nc-icon-mini ui-1_simple-remove" aria-hidden="true"></i></a>');

        // Get mobile menu width and move it the left/right offscreen by the width 
        this.elementWidth = this.mobileMenu.width();

        let direction = this.mobileMenu.hasClass('sma-mobile-menu-right') ? 'right' : 'left';
        this.mobileMenu.css(direction, (this.elementWidth*-1));

        // Show the mobile menu
        this.mobileMenu.show();

        // Animate the mobile menu from offscreen into position
        if(this.mobileMenu.hasClass('sma-mobile-menu-right')) {
            this.mobileMenu.animate({
                right: 0,
            }, 400);
        } else if(this.mobileMenu.hasClass('sma-mobile-menu-left')) {
            this.mobileMenu.animate({
                left: 0,
            }, 400);
        }
    }

    clickMenuClose(el) {
         this.menuShade.animate({
			opacity: 0,
		}, 400);

        if(this.mobileMenu.hasClass('sma-mobile-menu-right')) {
            this.mobileMenu.animate({
                right: this.elementWidth*-1
            }, 400, () => {
                this.menuShade.hide();
                let target = $(el.currentTarget);
                target.closest('.sma-mobile-menu-container').hide();
            });
        } else if(this.mobileMenu.hasClass('sma-mobile-menu-left')) {
            this.mobileMenu.animate({
                left: this.elementWidth*-1
            }, 400, () => {
                this.menuShade.hide();
                let target = $(el.currentTarget);
                target.closest('.sma-mobile-menu-container').hide();
            });
        }
    }
}

module.exports = {
	MobileMenu: MobileMenu
}